import { Alert, Snackbar } from '@mui/material'
import AlertState from 'src/types/alert/AlertState'
import SetAlertComponentCallback from 'src/types/alert/SetAlertComponentCallback'

interface AlertComponentProps {
  alertComponent: AlertState
  setAlertComponent: SetAlertComponentCallback
  alignment: { vertical: 'top' | 'bottom'; horizontal: 'left' | 'center' | 'right' }
}

/**
 * @deprecated Use `SnackbarAlert` instead.
 */
const AlertComponent = ({ alertComponent, setAlertComponent, alignment }: AlertComponentProps) => {
  const { vertical, horizontal } = alignment
  const { open, severity, message } = alertComponent

  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      autoHideDuration={6000}
      onClose={() => setAlertComponent({ open: false, severity, message })}
    >
      <Alert
        onClose={() => setAlertComponent({ open: false, severity, message })}
        severity={severity}
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

export default AlertComponent
